import { ConversationInsightsFiltersV1Schema } from "@redotech/redo-support-common/conversation-filters/conversation-insights-filters";
import { DateGroupingField } from "@redotech/redo-support-common/conversation-insights";
import { ConversationInsightsAnalyticsData } from "@redotech/redo-support-common/support/conversation-insights-analytics";
import * as z from "zod";

export const getConversationInsightsAnalytics = {
  name: "getConversationInsightsAnalytics" as const,
  input: z.object({
    filters: ConversationInsightsFiltersV1Schema.optional(),
    dateGroupingField: DateGroupingField.optional(),
  }),
  output: ConversationInsightsAnalyticsData,
};
